import { CircularProgress, Fade, CardContent } from "@mui/material"
import "./styles.scss"

function ExperimentLoading() {
  return <Fade in className="components_experiment-loading">
    <CardContent>
      <CircularProgress />
    </CardContent>
  </Fade>
}

export default ExperimentLoading
